export const allLanguages = [
  { name: "English", code: "EN" },
  { name: "French", code: "FR" },
  { name: "Spanish", code: "ES" },
];
